/**
 * covid19_dashboard copyright © 2020
 * Created by mauromarini on 30/08/20
 * Repository: http://github.com/marinimau/covid19_dashboard
 * Location: Baratili San Pietro
 */

import {chartTitles} from "./strings";

export const RegionList = [
    {label: chartTitles.allItaly, value: 0},
    {label: 'Abruzzo', value: 1},
    {label: 'Basilicata', value: 2},
    {label: 'Calabria', value: 3},
    {label: 'Campania', value: 4},
    {label: 'Emilia-Romagna', value: 5},
    {label: 'Friuli Venezia Giulia', value: 6},
    {label: 'Lazio', value: 7},
    {label: 'Liguria', value: 8},
    {label: 'Lombardia', value: 9},
    {label: 'Marche', value: 10},
    {label: 'Molise', value: 11},
    {label: 'P.A. Bolzano', value: 12},
    {label: 'P.A. Trento', value: 13},
    {label: 'Piemonte', value: 14},
    {label: 'Puglia', value: 15},
    {label: 'Sardegna', value: 16},
    {label: 'Sicilia', value: 17},
    {label: 'Toscana', value: 18},
    {label: 'Umbria', value: 19},
    {label: 'Valle d\'Aosta', value: 20},
    {label: 'Veneto', value: 21},
]